import React, {ReactNode} from 'react'
import { Box, Card, CardHeader, Avatar, IconButton } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import EventNoteIcon from '@mui/icons-material/EventNote'
import equal from 'fast-deep-equal'

interface ScheduleViewDetailItemBaseProps {
    icon: ReactNode
    action: ReactNode
    title: string
    detail: ReactNode
}

export const ScheduleViewDetailItemBase: React.FC<ScheduleViewDetailItemBaseProps> = props => {
    return (
        <Card square>
            <CardHeader
                style={{padding: '8px'}}
                avatar={<Avatar>{props.icon}</Avatar>}
                action={props.action && <Box padding={'8px 8px 0 0'}>{props.action}</Box>}
                title={props.title}
                subheader={props.detail}
            />
        </Card>
    )
}

interface SchedulesViewDetailItemProps {
    id: string
    multiple: boolean
    title: string
    detail: string
    onDelete?: (id: string) => void
}

const ScheduleViewDetailItem: React.FC<SchedulesViewDetailItemProps> = React.memo(props => {
    const icon = props.multiple
        ? <EventNoteIcon titleAccess={'複数日'}/>
        : <CalendarTodayIcon titleAccess={'単一日'}/>

    return (
        <ScheduleViewDetailItemBase
            icon={icon}
            action={props.onDelete &&
            <IconButton onClick={() => props.onDelete && props.onDelete(props.id)} size="large">
                <DeleteForeverIcon titleAccess={'削除'}/>
            </IconButton>
            }
            title={props.title}
            detail={props.detail}
        />
    );
}, (prevProps, nextProps) => (prevProps === nextProps || equal(prevProps, nextProps)))

ScheduleViewDetailItem.displayName = 'SchedulesViewDetailItem'
export default ScheduleViewDetailItem
